import React, { useRef, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { makeUID } from '../../../helpers';
import { isAdmin } from '../../../services/rolesSvc';
import DownloadAnchor from '../../common/DownloadAnchor';

export default function ModalUploadScan({
  show, onClose, onSave, scanFile, userCtx,
}) {
  const [localFile, setLocalFile] = useState(null);
  const [isShowConfirm, setIsShowConfirm] = useState(false);
  const [uploadInputKey, setUploadInputKey] = useState(makeUID(5));

  const inputRef = useRef(null);
  const handleUpload = () => inputRef.current?.click();

  const handleSave = async () => {
    const saveSuccess = await onSave(localFile);
    hideConfirm();
    if (saveSuccess) {
      handleFileChange(null);
    }
  };

  const showConfirm = () => setIsShowConfirm(true);

  const hideConfirm = () => setIsShowConfirm(false);

  const handleFileChange = (event) => {
    hideConfirm();
    if (event && event.target) {
      const { target } = event;
      const fileToSet = target.files.length ? target.files[0] : null;
      setLocalFile(fileToSet);
    } else {
      setLocalFile(null);
      setUploadInputKey(makeUID(5));
    }
  };

  const canEdit = isAdmin(userCtx);

  let actionPanel = null;

  if (isShowConfirm) {
    actionPanel = (
      <>
        <Button disabled={!localFile} onClick={handleSave} variant="outline-primary">
          Да
        </Button>
        <Button onClick={hideConfirm} variant="outline-secondary">
          Нет
        </Button>
      </>
    );
  } else {
    actionPanel = (
      <>
        <Button onClick={onClose} variant="outline-secondary">
          Отмена
        </Button>
        {(canEdit || !scanFile)
        && (
        <Button disabled={!localFile} onClick={showConfirm} variant="outline-primary">
          Загрузить
        </Button>
        )}
      </>
    );
  }

  const getConfirmMsg = () => {
    if (scanFile) {
      return 'Ранее загруженный скан будет заменён. Продолжить?';
    }
    return canEdit ? 'Подтвердите загрузку документа' : 'После подтверждения заменить документ нельзя. Продолжить?';
  };

  return (
    <Modal show={show} centered>
      <Modal.Header>Загрузка подписанного скана ЦП</Modal.Header>
      <Modal.Body>
        {(canEdit || !scanFile)
            && (
            <Form.Group md="12" className="mb-3">
              <Form.Control ref={inputRef} key={uploadInputKey} onChange={handleFileChange} type="file" className="d-none" />
              <Button onClick={handleUpload}>Выберите файл</Button>
            </Form.Group>
            )}
        { localFile
            && (
            <div className="mb-3 d-flex justify-content-between">
              <a href={URL.createObjectURL(localFile)} target="_blank" style={styleFileLink} rel="noreferrer">{localFile.name}</a>
              <Button onClick={() => handleFileChange(null)} variant="light" className="btn-close" size="sm" />
            </div>
            )}
        { isShowConfirm && (
          <span style={{ color: 'red' }}>{ getConfirmMsg() }</span>
        )}
        { scanFile && !isShowConfirm
            && (
            <Form.Group md="12" className="mb-3">
              <Form.Label><strong>Загруженный скан</strong></Form.Label>
              <DownloadAnchor
                url={`/minioFiles/download/${scanFile.id}`}
                filename={scanFile.name}
                className="d-block"
                style={styleFileLink}
              >
                {scanFile.name}
              </DownloadAnchor>
            </Form.Group>
            )}
      </Modal.Body>
      <Modal.Footer>
        {actionPanel}
      </Modal.Footer>
    </Modal>
  );
}

const styleFileLink = {
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  cursor: 'pointer',
};
